<div class="p-2 page-height overflow-auto bg-panel">
  <mat-card class="rounded-md page-container">
    <mat-card-content>
      <div>
        @if (page === 'payment') {
          <div class="page-header mb-4" data-test="app-pebl-header">
            <h4 class="mb-1">Payment Links</h4>
            <p class="text-muted mb-0">
              Create a secure link your customer can use to pay online.
            </p>
          </div>

          <ng-container *ngTemplateOutlet="paymentForm"></ng-container>
        }

        @if (page === 'payment-success') {
          <ng-container *ngTemplateOutlet="paymentSuccess"></ng-container>
        }
      </div>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #paymentForm>
  @if (formsActive) {
    <odin-dynamic-form
      [disabledInput]="!PermissionChecker()"
      [formData]="peblForm"
      [submit]="formSubmit"
    ></odin-dynamic-form>
  }

  <div class="mt-4">
    <mat-slide-toggle
        color="primary"
        [(ngModel)]="scheduleEnabled"
        (change)="OnScheduleToggle()"
        data-test="app-pebl-schedule-toggle"
        >Schedule this link</mat-slide-toggle
      >

      @if (scheduleEnabled) {
        <div class="mt-3">
          <mat-button-toggle-group
            [(ngModel)]="scheduleMode"
            data-test="app-pebl-schedule-mode"
          >
            <mat-button-toggle value="once">Send once</mat-button-toggle>
            <mat-button-toggle value="recurring">Recurring</mat-button-toggle>
          </mat-button-toggle-group>

          @if (scheduleMode === 'once') {
            <div class="d-flex gap-2 mt-3">
              <mat-form-field appearance="outline" class="w-50">
                <mat-label>Send date</mat-label>
                <input
                  matInput
                  [matDatepicker]="sendAtPicker"
                  [min]="minScheduleDate"
                  [(ngModel)]="sendAtDate"
                  (click)="sendAtPicker.open()"
                  data-test="app-pebl-send-at-date"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="sendAtPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #sendAtPicker></mat-datepicker>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-50">
                <mat-label>Send time</mat-label>
                <input
                  matInput
                  type="time"
                  [(ngModel)]="sendAtTime"
                  data-test="app-pebl-send-at-time"
                />
              </mat-form-field>
            </div>
          }

          @else if (scheduleMode === 'recurring') {
            <div class="d-flex gap-2 mt-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Frequency</mat-label>
                <mat-select
                  [(ngModel)]="frequency"
                  data-test="app-pebl-schedule-frequency"
                >
                  <mat-option value="daily">Daily</mat-option>
                  <mat-option value="weekly">Weekly</mat-option>
                  <mat-option value="monthly">Monthly</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="d-flex gap-2">
              <mat-form-field appearance="outline" class="w-50">
                <mat-label>Start date</mat-label>
                <input
                  matInput
                  [matDatepicker]="startPicker"
                  [min]="minScheduleDate"
                  [(ngModel)]="startDate"
                  (click)="startPicker.open()"
                  data-test="app-pebl-schedule-start-date"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="startPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-50">
                <mat-label>Start time</mat-label>
                <input
                  matInput
                  type="time"
                  [(ngModel)]="startTime"
                  data-test="app-pebl-schedule-start-time"
                />
              </mat-form-field>
            </div>

            <div class="mb-3">
              <mat-button-toggle-group
                [(ngModel)]="endCondition"
                data-test="app-pebl-schedule-end-condition"
              >
                <mat-button-toggle value="occurrences"
                  >Number of sends</mat-button-toggle
                >
                <mat-button-toggle value="endDate">End date</mat-button-toggle>
              </mat-button-toggle-group>
            </div>

            @if (endCondition === 'occurrences') {
              <mat-form-field appearance="outline" class="w-50">
                <mat-label>Number of sends</mat-label>
                <input
                  matInput
                  type="number"
                  min="1"
                  max="52"
                  [(ngModel)]="occurrences"
                  data-test="app-pebl-schedule-occurrences"
                />
                <mat-hint>Between 1 and 52</mat-hint>
              </mat-form-field>
            }

            @else if (endCondition === 'endDate') {
              <mat-form-field appearance="outline" class="w-50">
                <mat-label>End date</mat-label>
                <input
                  matInput
                  [matDatepicker]="endPicker"
                  [min]="startDate || minScheduleDate"
                  [max]="maxEndDate"
                  [(ngModel)]="endDate"
                  (click)="endPicker.open()"
                  data-test="app-pebl-schedule-end-date"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="endPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
              </mat-form-field>
            }
          }
        </div>
      }
    </div>

    <div class="mt-4">
      <p class="mb-2 text-center">Choose a method to send this payment link</p>
      <div class="d-flex align-items-center justify-content-center gap-4">
        @for (sendMethodItem of sendMethods; track sendMethodItem.sendType) {
          <div
            class="send-method-tile-wrap flex-fill"
            [matTooltip]="
              scheduleEnabled && isLink(sendMethodItem.sendType)
                ? 'A scheduled link must be sent by email or SMS'
                : ''
            "
          >
            <div
              class="send-method-tile p-2 rounded d-flex flex-column justify-content-center align-items-center border"
              (click)="SelectSendMethod(sendMethodItem.sendType)"
              [class.border-primary]="sendMethod === sendMethodItem.sendType"
              [class.text-primary]="sendMethod === sendMethodItem.sendType"
              [class.selected]="sendMethod === sendMethodItem.sendType"
              [class.disabled]="scheduleEnabled && isLink(sendMethodItem.sendType)"
            >
              <mat-icon>{{ sendMethodItem.icon }}</mat-icon>
              <p class="m-0">{{ sendMethodItem.viewName }}</p>
            </div>
          </div>
        }
      </div>
    </div>

  @if (formStage > 1) {
    <div class="mt-4">
      @if (formsActive) {
        <odin-dynamic-form
          [disabledInput]="!PermissionChecker() || isLink(sendMethod)"
          [refresh]="refreshFormState"
          [formData]="peblSendForm"
        ></odin-dynamic-form>
      }
    </div>
  }
</ng-template>

<ng-template #paymentSuccess>
  <div class="text-center">
    <div class="status-disc success mx-auto my-3">
      @if (scheduleResponse) {
        <mat-icon>event_available</mat-icon>
      } @else {
        <mat-icon>verified</mat-icon>
      }
    </div>

    @if (scheduleResponse) {
      <p class="mb-0 fw-bold">Your payment link is scheduled!</p>
      <p class="mb-0">
        Next send:
        {{ scheduleResponse.nextSendAt | date: 'd MMM yyyy, HH:mm' }}
      </p>
      @if (scheduleResponse.scheduleType === 'Recurring') {
        <p class="mb-0">
          Repeats {{ scheduleResponse.frequency }}
          @if (scheduleResponse.occurrencesTotal) {
            &mdash; {{ scheduleResponse.occurrencesTotal }} sends in total
          }
        </p>
      }
      <div
        class="reference-chip mx-auto mt-3"
        data-test="app-pebl-schedule-reference"
      >
        Schedule reference:
        <span class="reference-value">{{
          scheduleResponse.scheduleReference
        }}</span>
      </div>
    } @else {
      <p class="mb-0 fw-bold">Your payment link is active!</p>
      <p class="">Click below to copy to clipboard.</p>
    }

    @if (linkResponse) {
      <div
        class="px-2 mt-2 mx-auto d-flex justify-content-center align-items-center gap-2"
        style="max-width: 500px"
      >
        <div
          class="link-pill flex-grow-1 text-truncate"
          role="button"
          (click)="copyRespText()"
          data-test="app-pebl-link-pill"
        >
          {{ linkResponse.token }}
        </div>

        <button
          mat-flat-button
          class="copy-button"
          color="primary"
          (click)="copyRespText()"
          data-test="app-pebl-copy-resp-text-button"
        >
          <mat-icon>content_copy</mat-icon>
          Copy
        </button>
      </div>

      @if (qrEnabled) {
        <div class="qr-panel mx-auto mt-3" data-test="app-pebl-qr-panel">
          <qr-code
            value="{{ linkResponse.token }}"
            errorCorrectionKLevel="M"
          ></qr-code>
          <p class="text-muted small mb-0">Or let the customer scan</p>
        </div>
      }

      <p>{{ linkResponse.message }}</p>
    }

    <div class="mt-3">
      <button mat-flat-button color="primary" (click)="ResetPage()" data-test="app-pebl-reset-page-button">
        Create New Link
      </button>
    </div>
  </div>
</ng-template>
